export { BaseIcon } from './base-icon'
